(function () {
  'use strict';

  angular.module('app').component('clientTypeList', clientTypeList());

  function clientTypeList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        loadingItems: '<',
        onShowItem: '&',
        defaultLanguage: '<',
      },
      controller: ClientTypeListComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/client-types/client-type-list/client-type-list.component.html',
    };
  }

  ClientTypeListComponent.$inject = ['UtilService', 'AbilityService', 'ClientTypeService'];

  function ClientTypeListComponent(UtilService, AbilityService, ClientTypeService) {
    var vm = this;

    vm.permissions = {
      canShow: AbilityService.can('show_clienttype_accountadmin'),
      canUpdate: AbilityService.can('update_clienttype_accountadmin'),
      canDestroy: AbilityService.can('destroy_clienttype_accountadmin'),
    };

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = ClientTypeService.getFilterCriteria();

    // Methods
    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showItem = showItem;
    vm.deleteItem = deleteItem;
    vm.changeItemStatus = changeItemStatus;
    vm.changeItemDefault = changeItemDefault;

    vm.$onInit = function () {
      checkDefaultClientType(vm.items);
    };

    function fetchResult() {
      vm.filterCriteria.lang = vm.defaultLanguage;

      vm.loadingItems = true;
      ClientTypeService.getClientTypes(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        checkDefaultClientType(vm.items);

        vm.loadingItems = false;

        vm.showActions = false;
        vm.selectedAll = false;
      });
    }

    // refresh the data with the default filter criteria
    function refresh() {
      vm.filterCriteria = ClientTypeService.getFilterCriteria();
      fetchResult();
    }

    function selectPage() {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      fetchResult();
    }

    function showItem(item, mode) {
      if (!vm.permissions.canShow) {
        return;
      }
      vm.onShowItem({ item: item, mode: mode });
    }

    function deleteItem(item) {
      ClientTypeService.deleteClientType(item, fetchResult);
    }

    function changeItemStatus(item) {
      ClientTypeService.changeClientTypeStatus(item);
    }

    function changeItemDefault(item) {
      ClientTypeService.changeClientTypeDefault(item, fetchResult);
    }

    function checkDefaultClientType(items) {
      var found = false;

      for (var i = 0; i < items.length; i++) {
        var clientType = items[i];
        if (clientType.predefined) {
          found = true;
          break;
        }
      }

      vm.noDefaultClientType = !found;
    }
  }
})();
